export default "__VITE_ASSET__J52MQHgn__"